export default "__VITE_ASSET__2CZXQTNi__"